import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useContext, useState } from "react";
import { useDropzone } from "react-dropzone";

import DropArea from "../../components/DropArea";
import { AppContext } from "../../context/AppProvider";
import { AuthContext } from "../../context/AuthProvider";
import { fetchWithInterceptor } from "../../utils/fetchWithInterceptor";

export default function UploadDialog({ open, onClose }) {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);

  const handleChangeFile = (files) => setFile(files[0]);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: acceptedFiles => handleChangeFile(acceptedFiles),
    maxFiles: 1,
    maxSize: 10000000,
    accept: {
      'text/csv': ['.csv'],
      'application/vnd.ms-excel': ['.csv']
    }
  });

  const handleSubmit = async () => {
    if (!file) return;
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const response = await fetchWithInterceptor("/api/ats-fulfillment/upload", {
        method: "POST",
        body: formData,
        headers: {
          'x-access-token': authContext.getToken()
        },
      });
      setLoading(false);
      const data = await response.json();
      if (response.ok) {
        onClose(true, data.fileId);
      } else {
        appContext.showMessage(data?.message || "Invalid file", "error");
      }
    } catch (error) {
      appContext.showMessage("Invalid file", "error");
      setLoading(false);
    }
  };

  return (
    <Dialog
      disableEscapeKeyDown
      maxWidth="sm"
      aria-labelledby="delete-dialog"
      open={open}
    >
      <DialogTitle id="delete-dialog">Upload Manifest CSV File</DialogTitle>
      <DialogContent>
        <Box sx={{ minHeight: 200, mt: 1 }}>
          <DropArea {...getRootProps()}>
            <input {...getInputProps()} />
            <CloudUploadIcon sx={{ fontSize: 40, mb: 1 }} />
            <Typography  sx={{ textAlign: 'center', fontSize: '1.5rem' }}>
              Drag and drop the CSV file here or click
            </Typography>
          </DropArea>
        </Box>
        <Typography variant="subtitle1" sx={{ mt: 1 }}>
          {`Uploaded file: ${file ? file.name : "-"}`}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(false)} color="primary">Cancel</Button>
        <Button loading={loading} onClick={handleSubmit} color="primary" variant="contained" disabled={!file}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}